import { render } from "./TemplateModalRadarBoard.vue?vue&type=template&id=394a0b66&scoped=true&ts=true"
import script from "./TemplateModalRadarBoard.vue?vue&type=script&lang=ts"
export * from "./TemplateModalRadarBoard.vue?vue&type=script&lang=ts"

import "./TemplateModalRadarBoard.vue?vue&type=style&index=0&id=394a0b66&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-394a0b66"]])

export default __exports__